import {css} from "@panda/css";

import {Text} from "@pg-design/text-module";

export interface IPricesHubOffersCityFilterOption {
    value: string;
    label: string;
}

interface IProps {
    options: IPricesHubOffersCityFilterOption[];
    value: string;
    onChange: (value: string) => void;
    ariaLabel: string;
}

export const PricesHubOffersCityFilter = (props: IProps) => {
    const {options, value, onChange, ariaLabel} = props;

    return (
        <div role="group" aria-label={ariaLabel} className={groupStyle}>
            {options.map((option) => {
                const isActive = option.value === value;

                return (
                    <button
                        key={option.value}
                        type="button"
                        aria-pressed={isActive}
                        className={isActive ? activePillStyle : pillStyle}
                        onClick={() => onChange(option.value)}
                    >
                        <Text as="span" variant="body_copy_2">
                            {option.label}
                        </Text>
                    </button>
                );
            })}
        </div>
    );
};

const groupStyle = css({
    display: "inline-flex",
    alignItems: "center",
    width: "max-content",
    padding: 0.5,
    backgroundColor: "var(--colors-gray-200)",
    borderRadius: "999px"
});

const basePillStyle = {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    height: "3.2rem",
    px: 2,
    color: "var(--colors-secondary)",
    border: "1.5px solid transparent",
    borderRadius: "999px",
    cursor: "pointer",
    whiteSpace: "nowrap",
    transition: "background-color 160ms ease, border-color 160ms ease",

    md: {
        height: "4rem"
    },

    _focusVisible: {
        outline: "2px solid var(--colors-secondary)",
        outlineOffset: "2px"
    }
} as const;

const pillStyle = css({
    ...basePillStyle,
    backgroundColor: "transparent",

    "@media (hover: hover)": {
        _hover: {
            backgroundColor: "var(--colors-gray-300)"
        }
    }
});

const activePillStyle = css({
    ...basePillStyle,
    backgroundColor: "var(--colors-background-100)",
    borderColor: "var(--colors-secondary)",
    boxShadow: "1"
});
import {css} from "@panda/css";

import {Text} from "@pg-design/text-module";

export interface IPricesHubOffersCityFilterOption {
    value: string;
    label: string;
}

interface IProps {
    options: IPricesHubOffersCityFilterOption[];
    value: string;
    onChange: (value: string) => void;
    ariaLabel: string;
}

export const PricesHubOffersCityFilter = (props: IProps) => {
    const {options, value, onChange, ariaLabel} = props;

    return (
        <div role="group" aria-label={ariaLabel} className={groupStyle}>
            {options.map((option) => {
                const isActive = option.value === value;

                return (
                    <button
                        key={option.value}
                        type="button"
                        aria-pressed={isActive}
                        className={isActive ? activePillStyle : pillStyle}
                        onClick={() => onChange(option.value)}
                    >
                        <Text as="span" variant="body_copy_2">
                            {option.label}
                        </Text>
                    </button>
                );
            })}
        </div>
    );
};

const groupStyle = css({
    display: "inline-flex",
    alignItems: "center",
    width: "max-content",
    padding: 0.5,
    backgroundColor: "var(--colors-gray-200)",
    borderRadius: "999px"
});

const basePillStyle = {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    height: "3.2rem",
    px: 2,
    color: "var(--colors-secondary)",
    border: "1.5px solid transparent",
    borderRadius: "999px",
    cursor: "pointer",
    whiteSpace: "nowrap",
    transition: "background-color 160ms ease, border-color 160ms ease",

    md: {
        height: "4rem"
    },

    _focusVisible: {
        outline: "2px solid var(--colors-secondary)",
        outlineOffset: "2px"
    }
} as const;

const pillStyle = css({
    ...basePillStyle,
    backgroundColor: "transparent",

    "@media (hover: hover)": {
        _hover: {
            backgroundColor: "var(--colors-gray-300)"
        }
    }
});

const activePillStyle = css({
    ...basePillStyle,
    backgroundColor: "var(--colors-background-100)",
    borderColor: "var(--colors-secondary)",
    boxShadow: "1"
});
